import React from 'react';
import IconProps from '../../icons';

const CheckCircleLine = ({ width = 24, color = 'var(--success-600)' }: IconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    viewBox='0 0 24 24'
    fill='none'
  >
    <path
      d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default CheckCircleLine;
